var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticledrawer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08579 1.08579C4.46085 0.710719 4.96957 0.5 5.5 0.5H14.5C15.0304 0.5 15.5392 0.710706 15.9143 1.08579C16.2893 1.46088 16.5 1.96961 16.5 2.5V14.5C16.5 15.0304 16.2894 15.5391 15.9143 15.9143C15.5391 16.2894 15.0304 16.5 14.5 16.5H2.5C1.96961 16.5 1.46088 16.2893 1.08579 15.9143C0.710706 15.5392 0.5 15.0304 0.5 14.5V7.75C0.5 6.64886 1.39886 5.75 2.5 5.75H3.5V2.5C3.5 1.96957 3.71072 1.46085 4.08579 1.08579ZM3.5 6.75H2.5C1.95114 6.75 1.5 7.20114 1.5 7.75V14.5C1.5 14.7652 1.60537 15.0196 1.79289 15.2071C1.9804 15.3947 2.23475 15.5 2.5 15.5C2.76525 15.5 3.0196 15.3947 3.20711 15.2071C3.39463 15.0196 3.5 14.7652 3.5 14.5V6.75ZM4.23207 15.5C4.4061 15.1985 4.5 14.8541 4.5 14.5V2.5C4.5 2.23479 4.60536 1.98043 4.79289 1.79289C4.98043 1.60536 5.23479 1.5 5.5 1.5H14.5C14.7652 1.5 15.0196 1.60537 15.2071 1.79289C15.3947 1.9804 15.5 2.23475 15.5 2.5V14.5C15.5 14.7652 15.3946 15.0197 15.2071 15.2071C15.0197 15.3946 14.7652 15.5 14.5 15.5H4.23207Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10C6.5 9.72386 6.72386 9.5 7 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H7C6.72386 10.5 6.5 10.2761 6.5 10Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13C6.5 12.7239 6.72386 12.5 7 12.5H10.75C11.0261 12.5 11.25 12.7239 11.25 13C11.25 13.2761 11.0261 13.5 10.75 13.5H7C6.72386 13.5 6.5 13.2761 6.5 13Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 4C6.5 3.72386 6.72386 3.5 7 3.5H13C13.2761 3.5 13.5 3.72386 13.5 4V7C13.5 7.27614 13.2761 7.5 13 7.5H7C6.72386 7.5 6.5 7.27614 6.5 7V4ZM7.5 4.5V6.5H12.5V4.5H7.5Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticledrawer);
export default __webpack_public_path__ + "static/media/articledrawer.da0c3c22d173db096d22b98efd3095ba.svg";
export { ForwardRef as ReactComponent };